"use client"

import Markdown from "react-markdown"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog"
import React, { useState } from "react"
import { useDynamicConfig } from "../common/context/DynamicConfigContext"
import { ScrollArea } from "./ui/scroll-area"
import RenderIf from "./RenderIf"
import { cn } from "../common/utils/utils"
import { TermsAndConditionFieldsFragment } from "../types/gql/sdk"
interface ModalTermsProps {
  children?: React.ReactNode
  open?: boolean
  onClose?: () => void
  theme?: "light" | "dark"
  termsAndConditionals?: TermsAndConditionFieldsFragment | null
}

const ModalTermsAndConditions = ({
  children,
  onClose,
  open,
  theme,
  termsAndConditionals: termsOverride,
}: ModalTermsProps) => {
  const [isOpen, setIsOpen] = useState(open)
  const { termsAndConditionals: termsFromConfig } = useDynamicConfig()
  const termsAndConditionals = termsOverride ?? termsFromConfig
  const isControlled = typeof open === "boolean"
  const dialogOpen = isControlled ? !!open : !!isOpen

  const title = termsAndConditionals?.title || "Título Padrão"

  let content = termsAndConditionals?.content
  if (content) {
    content = content.replace(/\n/g, "\n\n")
  }

  const handleOpenModal = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    setIsOpen(true)
  }

  const handleOpenChange = (nextOpen: boolean) => {
    if (!isControlled) {
      setIsOpen(nextOpen)
    }

    if (!nextOpen) {
      onClose?.()
    }
  }

  return (
    <Dialog modal open={dialogOpen} onOpenChange={handleOpenChange}>
      <RenderIf condition={!!children}>
        <span onClick={handleOpenModal} role="button" tabIndex={0}>
          {children}
        </span>
      </RenderIf>
      <DialogContent className={cn("w-full max-w-[980px] p-12 gap-8 text-aon-text1", theme)}>
        <DialogHeader>
          <DialogTitle className="text-h3 font-semibold">{title}</DialogTitle>
        </DialogHeader>
        <ScrollArea
          classNameScrollBar="bg-transparent"
          classNameScrollAreaThumb="bg-aon-scroll"
          className="max-h-[520px] pr-6"
        >
          <Markdown className="markdown">{content}</Markdown>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}

export default ModalTermsAndConditions
